/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import {
  formatTextToSearch,
  removerCaracteresEspeciaisEAcentos,
  verifyIfContainDate,
} from './string-utils';

const regexDataHora = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}-\d{2}:\d{2}$/;

export interface MappingOption {
  [key: string]: string;
  from: string;
  to: string;
}
interface CheckIfIsMappingOptions {
  mappingOptions?: MappingOption[];
  valorDaPropriedadeDoObjeto: any;
}

function checkIfIsMappingOptions({
  mappingOptions,
  valorDaPropriedadeDoObjeto,
}: CheckIfIsMappingOptions): any {
  if (!mappingOptions) {
    return valorDaPropriedadeDoObjeto;
  }

  const mappingOption = mappingOptions.find(
    (option) => option.from === valorDaPropriedadeDoObjeto
  );

  if (mappingOption) {
    return mappingOption.to;
  }

  return valorDaPropriedadeDoObjeto;
}

function filtrarObjeto<T>(obj: T, valorPesquisado: any, options: any): any {
  const resultado: any = {};

  const isObject = (value: any) => typeof value === 'object' && value !== null;
  const isString = (value: any) => typeof value === 'string';
  const isNumber = (value: any) => typeof value === 'number';

  const shouldInclude = (value: any): boolean => {
    if (isString(value)) {
      if (regexDataHora.test(value)) {
        return verifyIfContainDate(value, valorPesquisado);
      }

      return removerCaracteresEspeciaisEAcentos(value)
        .toLowerCase()
        .includes(valorPesquisado);
    }

    if (isNumber(value)) {
      return String(value).includes(valorPesquisado);
    }

    return false;
  };

  for (const chave in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, chave) || chave === 'id')
      continue;

    let valorDaPropriedadeDoObjeto = checkIfIsMappingOptions({
      mappingOptions: options,
      valorDaPropriedadeDoObjeto: obj[chave],
    });

    if (Array.isArray(obj[chave]) || isObject(obj[chave])) {
      valorDaPropriedadeDoObjeto = obj[chave];
    }

    if (isObject(valorDaPropriedadeDoObjeto)) {
      const subResultado = filtrarObjeto(
        valorDaPropriedadeDoObjeto,
        valorPesquisado,
        options
      );

      if (Object.keys(subResultado).length > 0) {
        resultado[chave] = subResultado;
      }
    } else if (shouldInclude(valorDaPropriedadeDoObjeto)) {
      resultado[chave] = valorDaPropriedadeDoObjeto;
    }
  }

  return resultado;
}
function filterData<T>(data: T, filterValue: any, options: any): T | undefined {
  const filterFormatted = removerCaracteresEspeciaisEAcentos(filterValue);

  if (Array.isArray(data)) {
    return data
      .map((item) => {
        const have = filtrarObjeto(
          item,
          formatTextToSearch(filterFormatted),
          options
        );

        if (Object.keys(have).length > 0) {
          return item;
        }

        return undefined;
      })
      .filter((campanha) => campanha !== undefined) as T;
  }

  const have = filtrarObjeto(
    data,
    formatTextToSearch(filterFormatted),
    options
  );

  if (Object.keys(have).length > 0) {
    return data;
  }

  return undefined;
}

export { filterData };
